var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OzBaseButton',{class:[
    // Resets <button> background.
    // Invariant: OzTextButton doesn't have a background.
    // If you need a background, use OzContainedButton.
    'bg-transparent',

    // Color schemes
    _vm.colorScheme === _vm.ColorScheme.Primary && [
      // Base
      'text-padlet-pink',
      // Hovered
      'hover-hover:hover:text-padlet-pink-800',
      // Active
      'hover-hover:active:text-padlet-pink-800',
      // Focused
      'hover-hover:focus-visible:text-padlet-pink-800',
      // Disabled - Base
      {
        'disabled:text-padlet-pink-100': _vm.darkMode === false,
        'disabled:text-padlet-pink-900': _vm.darkMode === true,
        'disabled:text-padlet-pink-100 dark:disabled:text-padlet-pink-900': _vm.darkMode === 'auto',
      },
      // Disabled - Hover
      {
        'hover-hover:disabled:text-padlet-pink-100': _vm.darkMode === false,
        'hover-hover:disabled:text-padlet-pink-900': _vm.darkMode === true,
        'hover-hover:disabled:text-padlet-pink-100 hover-hover:dark:disabled:text-padlet-pink-900':
          _vm.darkMode === 'auto',
      } ],
    [_vm.ColorScheme.Secondary, _vm.ColorScheme.SecondaryMuted].includes(_vm.colorScheme) && [
      // Base
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
      // Hovered
      _vm.colorScheme === _vm.ColorScheme.Secondary && {
        'hover-hover:hover:text-grape-500': _vm.darkMode === false,
        'hover-hover:hover:text-canary-500': _vm.darkMode === true,
        'hover-hover:hover:text-grape-500 hover-hover:dark:hover:text-canary-500': _vm.darkMode === 'auto',
      },
      _vm.colorScheme === _vm.ColorScheme.SecondaryMuted && {
        'hover-hover:hover:text-dark-text-100': _vm.darkMode === false,
        'hover-hover:hover:text-light-text-100': _vm.darkMode === true,
        'hover-hover:hover:text-dark-text-100 hover-hover:dark:hover:text-light-text-100': _vm.darkMode === 'auto',
      },
      // Active
      {
        'hover-hover:active:text-grape-500': _vm.darkMode === false,
        'hover-hover:active:text-canary-500': _vm.darkMode === true,
        'hover-hover:active:text-grape-500 hover-hover:dark:active:text-canary-500': _vm.darkMode === 'auto',
      },
      // Focused
      {
        'hover-hover:focus-visible:text-grape-500': _vm.darkMode === false,
        'hover-hover:focus-visible:text-canary-500': _vm.darkMode === true,
        'hover-hover:focus-visible:text-grape-500 hover-hover:dark:focus-visible:text-canary-500':
          _vm.darkMode === 'auto',
      },
      // Disabled - Base
      {
        'disabled:text-dark-text-400': _vm.darkMode === false,
        'disabled:text-light-text-400': _vm.darkMode === true,
        'disabled:text-dark-text-400 dark:disabled:text-light-text-400': _vm.darkMode === 'auto',
      },
      // Disabled - Hover
      {
        'hover-hover:disabled:text-dark-text-400': _vm.darkMode === false,
        'hover-hover:disabled:text-light-text-400': _vm.darkMode === true,
        'hover-hover:disabled:text-dark-text-400 hover-hover:dark:disabled:text-light-text-400 ': _vm.darkMode === 'auto',
      } ],
    _vm.colorScheme === _vm.ColorScheme.Danger && [
      // Base
      'text-danger-100',
      // Hovered
      'hover-hover:hover:text-scarlet-600',
      // Active
      'hover-hover:active:text-scarlet-600',
      // Focused
      'hover-hover:focus-visible:text-scarlet-600',
      // Disabled - Base
      'disabled:text-scarlet-700',
      // Disabled - Hover
      'hover-hover:disabled:text-scarlet-700' ],
    _vm.colorScheme === _vm.ColorScheme.Active && [
      // Base
      {
        'text-grape-500': _vm.darkMode === false,
        'text-canary-500': _vm.darkMode === true,
        'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
      } ] ],attrs:{"href":_vm.href,"title":_vm.text},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }